import { useState, useEffect } from 'react';

export default function Footer() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-12 sm:pt-20 pb-6 sm:pb-8 relative">
      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-50 w-11 h-11 flex items-center justify-center rounded-full shadow-lg transition-all duration-300 cursor-pointer ${
          showButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        style={{ backgroundColor: '#D5BA6B' }}
        aria-label="Back to top"
      >
        <i className="ri-arrow-up-line text-white text-lg"></i>
      </button>

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-20">
          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wide font-bold mb-3 sm:mb-4 pb-2" style={{ color: '#D5BA6B' }}>
              Services
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Site Selection
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Event Management
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Incentive Travel
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Entertainment
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wide font-bold mb-3 sm:mb-4 pb-2" style={{ color: '#D5BA6B' }}>
              Company
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Portfolio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Careers
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wide font-bold mb-3 sm:mb-4 pb-2" style={{ color: '#D5BA6B' }}>
              Resources
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button onClick={() => scrollToSection('process')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Our Process
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('case-studies')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Case Studies
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  Industry Insights
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-xs sm:text-sm text-gray-300 transition-colors cursor-pointer leading-relaxed hover:text-[#D5BA6B]">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs sm:text-sm uppercase tracking-wide font-bold mb-3 sm:mb-4 pb-2" style={{ color: '#D5BA6B' }}>
              Contact
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                <i className="ri-phone-line mr-2"></i>
                (647) 493-5660
              </li>
              <li className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                <i className="ri-mail-line mr-2"></i>
                solutions@mgroupglobal.ca
              </li>
              <li className="text-xs sm:text-sm text-gray-300 leading-relaxed">
                <i className="ri-map-pin-line mr-2"></i>
                Toronto, Ontario
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 sm:pt-12 flex flex-col lg:flex-row justify-between items-center gap-6 sm:gap-8">
          <div className="text-left lg:text-left">
            <img
              src="https://static.readdy.ai/image/d808c48a5b990d9ac02bd9f33c7a3dc7/c12788db0a475cdcb4cdb431feb79929.png"
              alt="MGroup Agency"
              className="h-9 sm:h-20 lg:h-24 w-auto lg:mx-0 object-cover object-bottom"
              style={{ clipPath: 'inset(30% 0 0 0)' }}
            />
          </div>
        </div>

        <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row items-end justify-between gap-2 sm:gap-4">
          <p className="hidden sm:block text-[10px] sm:text-xs font-light text-gray-400 leading-none">
            Strategic Solutions for Your Success
          </p>
          <div className="flex items-end gap-3 sm:gap-6">
            <span className="text-[10px] sm:text-xs text-gray-500 leading-none">
              © 2026 MGroup Global. All rights reserved.
            </span>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[10px] sm:text-xs text-gray-500 transition-colors leading-none hover:text-[#D5BA6B]"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
